import React, { FormEvent, useState } from "react";
import { useParams } from "react-router-dom";

import { useUser } from "@/shared/lib/hooks/useUser/useUser";
import { useNavigate } from "react-router-dom";

export const LoginPage = () => {
    const { setUser, user } = useUser();
    const navigate = useNavigate();
    const { lang } = useParams();

    // Hardcoded credentials
    const VALID_USERNAME = "admin";
    const VALID_PASSWORD = "1ZU[9`<*1C'TJfckfH";
    console.log("user", user);
    // State for authentication
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");

    const handleLogin = (e: FormEvent) => {
        e.preventDefault();

        if (username === VALID_USERNAME && password === VALID_PASSWORD) {
            setUser(username);
            setError("");
            navigate(`/${lang}`);
        } else {
            setError("Invalid username or password");
        }
    };
    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                minHeight: "100vh",
                backgroundColor: "#f0f2f5",
            }}
        >
            <div
                style={{
                    backgroundColor: "white",
                    padding: "40px",
                    borderRadius: "8px",
                    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                    width: "100%",
                    maxWidth: "400px",
                }}
            >
                <h2 style={{ textAlign: "center", marginBottom: "30px" }}>
                    Login
                </h2>

                <form onSubmit={handleLogin}>
                    <div style={{ marginBottom: "20px" }}>
                        <label
                            style={{
                                display: "block",
                                marginBottom: "5px",
                                fontWeight: "500",
                            }}
                        >
                            Username
                        </label>
                        <input
                            type="text"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            style={{
                                width: "100%",
                                padding: "10px",
                                border: "1px solid #ddd",
                                borderRadius: "4px",
                                fontSize: "16px",
                                boxSizing: "border-box",
                            }}
                            required
                        />
                    </div>

                    <div style={{ marginBottom: "20px" }}>
                        <label
                            style={{
                                display: "block",
                                marginBottom: "5px",
                                fontWeight: "500",
                            }}
                        >
                            Password
                        </label>
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            style={{
                                width: "100%",
                                padding: "10px",
                                border: "1px solid #ddd",
                                borderRadius: "4px",
                                fontSize: "16px",
                                boxSizing: "border-box",
                            }}
                            required
                        />
                    </div>

                    {error && (
                        <div
                            style={{
                                color: "red",
                                marginBottom: "20px",
                                textAlign: "center",
                                fontSize: "14px",
                            }}
                        >
                            {error}
                        </div>
                    )}

                    <button
                        type="submit"
                        style={{
                            width: "100%",
                            padding: "12px",
                            backgroundColor: "#007bff",
                            color: "white",
                            border: "none",
                            borderRadius: "4px",
                            fontSize: "16px",
                            fontWeight: "500",
                            cursor: "pointer",
                        }}
                    >
                        Login
                    </button>
                </form>
            </div>
        </div>
    );
};
